import { ReactElement, useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "./Sidebar/Sidebar";
import Header_User from "./Header/Header_User";
// import Profilepop from './Profilepop';
import Sidebar_Program from "./Sidebar/Sidebar_Program";
import {
  // AllPrograms,
  // CardDashboard,
  // PaidInternship, Quiz,
  MyCoursesV1,
  Lms_V1_test,
  ResumeV1,
  ChallengeV1,
  AiEvaluationV1,
  // AiEvaluationV2,
  // ReferAndEarn_V1,
  ProfileSetting_V1,
  InternshipsV2,
  InternshipsV1,
  Notes,
  ReferAndEarn_V1,
  InternshipsV3,
  // AiEvaluationV2
} from "Pages/index";
import { useView } from "Context/viewContext";
import { useEnroll } from "Context/enrollContext";
// import Header_Lms from './Header/Header_Lms';
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "Context/authContext";
import { useUser } from "Context/userContext";
import BookingPopup from "Components/v1/BookingPopup";

interface MenuItem {
  title?: string; // Title of the menu item
  id?: string; // Unique identifier for the menu item
  element?: ReactElement; // React element to render for this menu item
  status?: string; // Status or additional metadata for the menu item
  subMenu?: Array<any>; // Nested submenu items
  icon?: string;
}

export default function DashboardWrapperV2(): ReactElement {
  const { menu } = useParams();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { currentUser } = useAuth();
  const { user } = useUser();
  const queryClient = useQueryClient();
  const { isMobile } = useView();
  const { enroll } = useEnroll();
  const [currentMenu, setCurrentMenu] = useState(menu);
  const [element, setElement] = useState<any>();
  const [isMenuActive, setIsMenuActive] = useState<boolean>(
    isMobile ? false : true
  );
  const isCourseDashboard = window.location.pathname.includes("program");
  const navigate = useNavigate();

  const [isSubMenuOpen, setIsSubMenuOpen] = useState<any>(false);

  const getSectionStatus = (
    section: string,
    step: string | undefined
  ): string => {
    const statusMap: { [key: string]: { [key: string]: string } } = {
      assessment: {
        ASSESSMENT: "UNLOCKED",
        INTERNSHIP: "COMPLETED",
        DONE: "COMPLETED",
        default: "LOCKED",
      },
      internship: {
        INTERNSHIP: "UNLOCKED",
        DONE: "COMPLETED",
        default: "LOCKED",
      },
      paid: {
        DONE: "UNLOCKED",
        default: "LOCKED",
      },
    };
    return statusMap[section]?.[step ?? "default"] ?? "LOCKED";
  };
  const refetch = async () => {
    // Us e refetchQueries to trigger a refetch of specific queries
    if (!currentUser) return;

    await queryClient.refetchQueries({ queryKey: ["courses"], type: "active" });
    await queryClient.refetchQueries({
      queryKey: ["updateProfile"],
      type: "active",
    });
    await queryClient.refetchQueries({ queryKey: ["resume"], type: "active" });
  };
  useEffect(() => {
    refetch();
  }, [currentUser]);
  // console.log('isCourseDashboard-', isCourseDashboard)
  const menuArr: MenuItem[] = useMemo(() => {
    if (!isCourseDashboard) {
      const commonMenu = [
        {
          title: "My Programs",
          id: "course",
          element: <MyCoursesV1 />,
          icon: "HomeIcon",
          subMenu:
            enroll?.courses?.map((enroll: any) => ({
              ...enroll,
            })) || [],
        },
        {
          title: "My Resume",
          id: "resume",
          element: <ResumeV1 />,
          icon: "ResumeIcon",
        },
        {
          title: "Refer N Earn",
          id: "referral",
          element: <ReferAndEarn_V1 />,
          icon: "ReferAndEarnIcon",
        },
        {
          title: "Profile Settings",
          id: "profile",
          element: <ProfileSetting_V1 />,
          icon: "SettingsIcon",
        },
      ];

      // if (user.cardId) {
      //   return [
      //     ...commonMenu,
      //     { title: 'My Card', id: 'card', element: <CardDashboard /> }
      //   ]
      // }

      if (user.paymentStatus === "PAID") {
        return [
          ...commonMenu,
          // { title: 'Explore more Programs', id: 'all', element: <AllPrograms /> },
        ];
      } else {
        return [...commonMenu];
      }
    } else {
      const finalMenu = enroll.menu
        ?.map((item) => {
          const status = getSectionStatus(item.toLowerCase(), enroll.step);
          switch (item) {
            case "RESUME":
              return {
                title: "My Resume",
                id: "resume",
                element: <ResumeV1 />,
                status: "UNLOCKED",
                icon: "ResumeIcon",
              };
            case "CHALLENGE":
              return {
                title: "My Challenge",
                id: "assessment",
                element: <ChallengeV1 />,
                status,
                icon: "ChallengeIcon",
              };
            // case 'QUIZ':
            //   return { title: 'My Quiz', id: 'quiz', element: <Quiz />, status: 'UNLOCKED', icon: "QuizIcon", };
            case "INTERNSHIP":
              return {
                title: "My Internship",
                id: "internship",
                element: <InternshipsV1 />,
                status,
                icon: "InternshipIcon",
              };
            case "INTERNSHIPV1":
              return {
                title: "My Internship",
                id: "internship",
                element: <InternshipsV2 />,
                status,
                icon: "InternshipIcon",
              };

            case "INTERNSHIPV3":
              return {
                title: "My Internship",
                id: "internship",
                element: <InternshipsV3 />,
                status,
                icon: "InternshipIcon",
              };
            case "INTERVIEW":
              return {
                title: "My Interview",
                id: "interview",
                element: <AiEvaluationV1 />,
                status,
                icon: "AiInterview",
              };
            case "LMS_HYBRID":
            case "LMS_LIVE":
              return {
                title: "My Learning (LMS)",
                id: "learning",
                element:
                  item === "LMS_HYBRID" ? <Lms_V1_test /> : <Lms_V1_test />,
                status: "UNLOCKED",
                icon: "LmsIcon",
              };
            // case 'INTERNSHIP_PAID':
            //   return enroll.isPaidInternshipAvailable
            //     ? { title: 'Paid Internship', id: 'alpha', element: <PaidInternship />, status }
            //     : null;
            default:
              return null;
          }
        })
        .filter((item) => item !== null) as MenuItem[];

      if (enroll.planType !== "DI")
        finalMenu?.push({
          title: "Notes",
          id: "notes",
          element: <Notes />,
          status: "NOTES",
          icon: "NotesIcon",
        });

      if (enroll.planType === "COMBO")
        finalMenu?.push({
          title: "Book Doubt",
          id: "doubt",
          status: "Doubt",
          icon: "DoubtIcon",
        });

      if (
        !enroll.title?.toLowerCase().includes("intl") &&
        !enroll.title?.toLowerCase().includes("sports") &&
        !enroll.title?.includes("Finance Management Internship Program")
      )
        finalMenu?.push({
          title: "Join Community",
          id: "what",
          element: <Notes />,
          status: "NOTES",
          icon: "what",
        });

      if (enroll.title) {
        finalMenu?.unshift({
          title: enroll.title,
          id: "title",
          status: "NONE",
        });
      }
      // finalMenu?.push({ title: 'Interview', id: 'interview', element: <AiEvaluationV2 />, status: 'NONE',icon: "AiInterview" });
      return finalMenu;
    }
  }, [
    isCourseDashboard,
    enroll.menu,
    user.paymentStatus,
    enroll.title,
    enroll.step,
    enroll.courses,
  ]);

  useEffect(() => {
    setCurrentMenu(menu);
    setElement(menuArr?.find((menuItem) => menuItem.id === menu)?.element);
  }, [menu, menuArr, isCourseDashboard]);

  useEffect(() => {
    const enrollItem = JSON.parse(
      atob(sessionStorage.getItem("cohort") || "") || `{}`
    );
    // if (isCourseDashboard && (!enrollItem.menu || enrollItem?.menu?.length === 0))
    console.log(enrollItem);

    if (false) return navigate("/v1/user/dashboard/course");
  }, [enroll.menu]);

  const [isSidebarOpen, setIsSideBarOpen] = useState<any>(false);

  // console.log('menuAr-',menuArr);

  return (
    <div className="font-youvah overflow-hidden">
      {/* <Profilepop /> */}
      <div className={`h-screen w-full flex overflow-hidden`}>
        <BookingPopup
          isOpen={isPopupOpen}
          onClose={() => {
            setIsPopupOpen(false);
          }}
        />
        {isCourseDashboard ? (
          <Sidebar_Program
            setIsPopupOpen={setIsPopupOpen}
            currentMenu={currentMenu}
            setCurrentMenu={setCurrentMenu}
            menuArr={menuArr}
            isMenuActive={isMenuActive}
            setIsMenuActive={setIsMenuActive}
          />
        ) : (
          <Sidebar
            getSectionStatus={getSectionStatus}
            isSidebarOpen={isSidebarOpen}
            setIsSideBarOpen={setIsSideBarOpen}
            setIsSubMenuOpen={setIsSubMenuOpen}
            isSubMenuOpen={isSubMenuOpen}
            currentMenu={currentMenu}
            setCurrentMenu={setCurrentMenu}
            menuArr={menuArr}
            isMenuActive={isMenuActive}
            setIsMenuActive={setIsMenuActive}
            isMobile={isMobile}
          />
        )}

        <div
          className={`w-full h-[100dvh] overflow-y-scroll no-scrollbar  bg-[#fff] ${
            isMenuActive && isMobile ? "blur-md" : "bg-opacity-100"
          }`}
        >
          <Header_User
            setIsSubMenuOpen={setIsSubMenuOpen}
            isMenuActive={isMenuActive}
            setIsMenuActive={setIsMenuActive}
          />
          <div className="h-[calc(100dvh-100px)]">{element}</div>
        </div>
      </div>
    </div>
  );
}
